import React from 'react'
import PropTypes from 'prop-types'
import { Image, Item, Paragraph } from 'LiveBoard/components/shared/SideBySide/SectionTypes'
import { IMAGE, ITEM, PARAGRAPH } from 'LiveBoard/components/shared/SideBySide/constants'
import map from 'lodash/map'
import every from 'lodash/every'
import { triggerClickOnEnter } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const StripsRenderer = (props) => {
  const SECTION_COMPONENT_TYPE = {
    [IMAGE]: Image,
    [ITEM]: Item,
    [PARAGRAPH]: Paragraph
  }

  const getSectionType = sideType => SECTION_COMPONENT_TYPE[sideType]
  const device = props.isMobile ? "mobile" : "desktop"

  const STRIP_CONTAINER_TYPE = {
    images: "images",
    paragraphs: "paragraphs",
    mixed: "mixed"
  }

  const handleItemClick = ({ item }) => {
    props.onItemClick({item})
  }

  const handleSectionClick = (type, data) => {
    type == ITEM && handleItemClick(data)
  }

  const checkSectionsType = (stripSections, type) => {
    return every(stripSections, ['type', type])
  }

  const getStripContainerType = (stripSections) => {
    if (checkSectionsType(stripSections, PARAGRAPH)) {
      return STRIP_CONTAINER_TYPE.paragraphs
    }
    else if (checkSectionsType(stripSections, IMAGE)) {
      return STRIP_CONTAINER_TYPE.images
    }
    else {
      return STRIP_CONTAINER_TYPE.mixed
    }
  }

  return (
    <div className={`strips-container-${device}`}>
      {
        map(props.strips, (strip, stripKey) => {
          return (
            <div
              className={`strip-container ${getStripContainerType(strip.sections)}`}
              key={stripKey}>
              {
                map(strip.sections, (section, sectionKey) => {
                  const SpecificSection = getSectionType(section.type)
                  const data = section.data[section.type.toLowerCase()]
                  return (
                    <SpecificSection
                      key={sectionKey}
                      data={data}
                      onClick={handleSectionClick}
                      onKeyDown={triggerClickOnEnter}
                      themeColorHex={props.themeColorHex} />
                  )
                })
              }
            </div>
          )
        })
      }
    </div>
  )
}

StripsRenderer.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  strips: PropTypes.object.isRequired,
  onItemClick: PropTypes.func.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default StripsRenderer
